import { useQuery } from '@tanstack/react-query';
import { useCompany } from '@/contexts/CompanyContext';
import { useDirection } from '@/contexts/DirectionContext';
import { billRowsApi } from '../api/bill-rows.api';
import type { BillModalData } from '../interfaces/bill-row.interface';

interface UseBillModalResult {
  data: BillModalData | undefined;
  isLoading: boolean;
  isFetching: boolean;
  error: Error | null;
}

/**
 * Fetch lazy al detaliilor unui B/L pentru modal. Disabled când id nu e valid.
 */
export function useBillModal(id: number | null | undefined): UseBillModalResult {
  const { selectedCompanyId } = useCompany();
  const { direction } = useDirection();
  const companyId = typeof selectedCompanyId === 'number' ? selectedCompanyId : undefined;

  const query = useQuery<BillModalData>({
    queryKey: ['bills', 'modal', id, selectedCompanyId, direction],
    queryFn: () => billRowsApi.getModalData(id as number, companyId, direction),
    enabled: typeof id === 'number' && id > 0,
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    error: (query.error as Error) || null,
  };
}
